import styled from "@emotion/styled";

export const Title = styled.div`
  color: #1b4191;
  font-weight: 400;
  font-size: 48px;
  font-family: Angkor;
  font-style: normal;
  line-height: 48px; /* 100% */
  letter-spacing: -1.92px;
  text-align: center;

  ${props => props.theme.breakpoints.down("tablet")} {
    font-size: 32px;
    line-height: 36px; /* 112.5% */
    letter-spacing: -0.96px;
  }
`;

export const Message = styled.div`
  p {
    color: #333333;
    font-weight: 400;
    font-size: 20px;
    font-family: Fredoka;
    font-style: normal;
    line-height: 24px; /* 120% */
    text-align: center;
  }

  p + p {
    margin-block-start: 20px;
  }

  a {
    color: #000000;
    font-family: Fredoka;
    line-height: 140%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;

    cursor: pointer;
  }

  ${props => props.theme.breakpoints.down("tablet")} {
    p {
      font-size: 18px;
    }
  }
`;

export const Button = styled.button`
  position: relative;

  display: block;

  min-inline-size: 140px;
  margin-block: 22px;
  margin-inline: auto;
  padding-block: 12px;
  padding-inline: 24px;
  box-sizing: border-box;

  border-radius: 100px;

  background: #ffffff;

  cursor: pointer;

  &:before {
    position: absolute;
    inset-block: 4px -4px;
    inset-inline: -4px 4px;
    content: "";

    border-radius: 100px;

    background-color: #fecc17;
  }

  &:after {
    position: absolute;
    inset: 0;
    content: "";
    z-index: 1;

    border: 2px solid #000000;
    border-radius: 100px;
  }

  ${props => props.theme.breakpoints.down("desktop")} {
    margin-block: 8px 16px;
    margin-inline: auto;
  }

  span {
    position: relative;

    font-weight: 600;
    font-size: 14px;
    font-family: Fredoka, sans-serif;
    line-height: 20px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  place-self: center;

  max-inline-size: 670px;
  padding: 20px;

  ${Message} {
    margin-block-start: 24px;
  }

  ${Button} {
    margin-block-start: 40px;
  }

  ${props => props.theme.breakpoints.down("tablet")} {
    ${Button} {
      margin-block-start: 32px;
    }
  }
`;
